import { create } from 'zustand';
import axios from 'axios';

const BLUEPRINT_URL =
  'https://raw.githubusercontent.com/float16-cloud/examples/main/official/blueprint/.available.json';

export interface BluePrintItem {
  bluePrintName: string;
  bluePrintPath: string;
  category?: string;
  description?: string;
  tags?: string[];
}

export interface AvailableBlueprints {
  version: number;
  experimentBluePrint: BluePrintItem[];
  productionBluePrint: BluePrintItem[];
}

export interface BlueprintReadme {
  path: string;
  audience: string;
  language: string;
  fileName: string;
}

export interface BlueprintFileItem {
  path: string;
  fileName: string;
}

export interface BlueprintDeploymentFile {
  path: string;
  fileName: string;
}


export interface BlueprintDetail {
  version: number;
  readme: BlueprintReadme[];
  fileList: BlueprintFileItem[];
  deploymentFile: BlueprintDeploymentFile;
  information: {
    type: string;
  }
}

interface BlueprintStore {
  data: AvailableBlueprints | null;
  loading: boolean;
  error: string | null;
  getByName: (name: string) => BluePrintItem | undefined;
}

export const useBlueprintStore = create<BlueprintStore>((set, get) => {
  // fetch ข้อมูลทันทีที่ store ถูกสร้าง
  (async () => {
    set({ loading: true, error: null });
    try {
      const res = await axios.get(BLUEPRINT_URL);
      if (res.data) {
        const parsed: AvailableBlueprints = res.data;
        set({ data: parsed, loading: false });
      } else {
        set({ error: 'No content found', loading: false });
      }
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  })();

  return {
    data: null,
    loading: false,
    error: null,
    getByName: (name: string) => {
      const { data } = get();
      if (!data) return undefined;

      return data.productionBluePrint.find(
        (blueprint) => blueprint.bluePrintName === name
      );
    }
  };
});

export const fetchBlueprintDetailByPath = async (path: string) => {
  try {
    const url = `https://raw.githubusercontent.com/float16-cloud/examples/main/${path}/.blueprint.json`;
    const res = await axios.get(url);
    if (res.data) {
      const parsed: BlueprintDetail = res.data;
      return parsed;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const getReadme = async (path: string, name: string) => {
  try {
    const url = `https://raw.githubusercontent.com/float16-cloud/examples/main/${path}/${name}`;
    const res = await axios.get(url);
    
    if (res.data) {
      return res.data;
    }
    
    return null;
  } catch (err) {
    return null;
  }
};


export const getFileOnGit = async (path:string) => {
  try {
    const url = `https://raw.githubusercontent.com/float16-cloud/examples/main/${path}`;
    const res = await axios.get(url);

    if (res.data) {
      return res.data;
    }

    return null;
  } catch (err) {
    return null;
  }
};



